import { get } from '@/services/http';
import { SurveyResponseModel } from '@/models/survey_response';
import List from './list';

export interface SurveyResponseFilters {
  survey_type?: string;
  feature_code?: string;
  answer?: string;
  from?: string;
  to?: string;
}

export interface SurveyResponseStats {
  total: number;
  byAnswer: Record<string, number>;
  byFeature: Record<string, number>;
  byDate: Array<{ date: string; count: number }>;
}

export class SurveyResponseList extends List<SurveyResponseModel> {
  public lastPage: number = 0;
  public total: number = 0;

  public async fetch(
    page: number = 1,
    pageSize: number = 50,
    filters: SurveyResponseFilters = {},
  ) {
    const data: any = {
      page,
      limit: pageSize,
      ...filters,
    };
    const res: any = await get('/survey-responses', data);
    this.items = [];
    const responses = res.data?.responses || [];
    this.total = res.data?.total || 0;
    this.lastPage = res.data?.totalPages || 0;
    for (const s of responses) {
      const model = new SurveyResponseModel();
      model.mapData(s);
      this.add(model);
    }
  }

  public async fetchStats(filters: SurveyResponseFilters = {}): Promise<SurveyResponseStats> {
    const data: any = { ...filters };
    const res: any = await get('/survey-responses/stats', data);
    return res.data;
  }

  public async exportCsv(filters: SurveyResponseFilters = {}): Promise<Blob> {
    const identity: string = localStorage.getItem('token') || '';
    const host = process.env.VUE_APP_BACKEND_API_URL;
    const params = new URLSearchParams();
    if (filters.survey_type) params.set('survey_type', filters.survey_type);
    if (filters.feature_code) params.set('feature_code', filters.feature_code);
    if (filters.from) params.set('from', filters.from);
    if (filters.to) params.set('to', filters.to);

    const response = await fetch(
      `${host}/survey-responses/export?${params.toString()}`,
      {
        headers: {
          Authorization: identity ? `Bearer ${identity}` : '',
        },
      },
    );
    return response.blob();
  }
}
